import { useAuth } from './useAuth';
import { supabase } from '@/integrations/supabase/client';
import { useQuery } from '@tanstack/react-query';

export type AppRole = 'admin' | 'user' | 'investor';

interface UseUserRoleResult {
  role: AppRole | null;
  isAdmin: boolean;
  isUser: boolean;
  isInvestor: boolean;
  loading: boolean;
}

export function useUserRole(): UseUserRoleResult {
  const { user, session } = useAuth();

  const { data: role = null, isLoading } = useQuery({
    queryKey: ['user-role', user?.id],
    queryFn: async () => {
      const { data, error } = await (supabase as any)
        .from('user_roles')
        .select('role')
        .eq('user_id', user!.id)
        .maybeSingle();
      if (error) throw error;
      return (data?.role as AppRole) ?? null;
    },
    enabled: !!user?.id && !!session,
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
  });

  return {
    role,
    isAdmin: role === 'admin',
    isUser: role === 'user',
    isInvestor: role === 'investor',
    loading: (!!user?.id && isLoading) || (!!user?.id && !session),
  };
}
